var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_33515",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_33515)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#F1361D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63379 2.48058L9.46388 2.61266L10.0865 3.14186L10.228 2.36711L10.795 1.78604L9.96488 1.65395L9.3423 1.12476L9.20079 1.89951L8.63379 2.48058ZM10.8572 5.1904L11.5766 4.7818L12.4184 4.79997L11.9806 4.1286L12.0001 3.34288L11.2808 3.75148L10.4389 3.73331L10.8767 4.40468L10.8572 5.1904ZM9.88145 9.57667L9.17784 10.0085L9.16792 9.22257L8.7053 8.56587L9.54731 8.55661L10.2509 8.12483L10.2608 8.91071L10.7235 9.56741L9.88145 9.57667ZM10.4925 7.54512L11.3294 7.45854L12.0842 7.80707L11.9914 7.02592L12.3648 6.32149L11.5279 6.40808L10.7732 6.05954L10.8659 6.84069L10.4925 7.54512Z",
    fill: "#FFDC42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71422 6.58136L3.69895 7.92222L4.44252 5.71902L2.45345 4.34451L4.92826 4.32371L5.71422 2.13336L6.50017 4.32371L8.97498 4.34451L6.98591 5.71902L7.72948 7.92222L5.71422 6.58136Z",
    fill: "#FFDC42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/CN.e2c29a4af04a35846b57553c71c7b9a8.svg";
export { ForwardRef as ReactComponent };